import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { AppStatusDoc } from '@rock/types';
import type { FC, PropsWithChildren } from 'react';

/**
 * The explainer at the top of each App Status tool page: what the tool does and exactly what the
 * user will see, with an optional in-app screenshot. Content stays honest about blast radius —
 * these tools publish to every user.
 */
export const AppStatusGuidanceCard: FC<
    PropsWithChildren<{
        title: string;
        screenshot?: { src: string; alt: string };
    }>
> = ({ title, screenshot, children }) => (
    <Card>
        <CardHeader>
            <CardTitle>{title}</CardTitle>
            <CardDescription className="space-y-2">{children}</CardDescription>
        </CardHeader>
        {screenshot && (
            <CardContent>
                <img src={screenshot.src} alt={screenshot.alt} className="max-h-96 rounded-lg border shadow-sm" />
            </CardContent>
        )}
    </Card>
);

/** "Live since …" footer line for a tool's form card, from the live doc's publish-restamped updatedAt. */
export const LiveSince: FC<{ live: AppStatusDoc | undefined }> = ({ live }) => {
    if (!live) {
        return <div className="field-hint">Never published.</div>;
    }
    return (
        <div className="field-hint">
            Live since {new Date(live.updatedAt).toLocaleString()}
            {' · '}
            {'enabled' in live ? (live.enabled ? 'ENABLED' : 'disabled') : 'published'}
        </div>
    );
};
